var _path, _path2, _path3, _path4, _path5, _path6, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfref(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 142,
    viewBox: "0 0 167 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.6082 5.12783C70.0296 5.12783 71.1568 3.99378 71.1568 2.56391C71.1568 1.13404 70.0296 0 68.6082 0C67.1869 0 66.0596 1.13404 66.0596 2.56391C66.0596 3.99378 67.1869 5.12783 68.6082 5.12783Z",
    fill: "#CFCFCF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6543 129.045V140.336",
    stroke: "#BABABA",
    strokeWidth: 3.07256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.07324 134.713H14.297",
    stroke: "#BABABA",
    strokeWidth: 3.07256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M116.608 136.128C118.03 136.128 119.157 134.994 119.157 133.564C119.157 132.134 118.03 131 116.608 131C115.187 131 114.06 132.134 114.06 133.564C114.06 134.994 115.187 136.128 116.608 136.128Z",
    fill: "#CFCFCF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M159.209 9.21875V20.5098",
    stroke: "#BABABA",
    strokeWidth: 3.07256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M153.628 14.8867H164.852",
    stroke: "#BABABA",
    strokeWidth: 3.07256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11253_30968)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.277 101.734L27.7171 61.248C27.508 60.6584 27.8184 60.0053 28.408 59.7899C47.5508 52.905 69.1214 46.5016 87.5606 38.6339C88.3845 38.1141 89.0311 38.6276 89.3861 39.6102L112.262 98.5767L118.474 115.853C118.684 116.442 118.379 117.102 117.79 117.311L74.0149 133.053L56.9511 139.19C56.3615 139.405 55.7086 139.095 55.4932 138.505L42.277 101.734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.4162 88.3015L47.1458 45.9008C47.038 45.2795 47.4565 44.6899 48.0714 44.5821L98.1406 35.998L109.607 34.1087C110.235 33.8361 111.255 34.153 111.496 35.5542L123.882 97.4056L126.982 115.499C127.089 116.115 126.671 116.71 126.056 116.818L80.2082 124.68L62.3332 127.748C61.7183 127.85 61.1225 127.431 61.0147 126.816L54.4162 88.3015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.4436 75.798V116.563C68.4436 117.216 68.9761 117.755 69.629 117.755H88.5499H116.561H120.586H137.079C137.732 117.755 138.264 117.216 138.264 116.563V97.4105V44.5047V43.9532H126.221C125.061 43.9532 122.652 44.118 122.652 41.4871L122.627 29.7266H69.6288C68.9759 29.7266 68.4434 30.2591 68.4434 30.9122V41.0876V45.3924V75.798H68.4436Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3495 52.9316C41.5671 55.2141 34.8481 57.4773 28.408 59.7913C27.8184 60.0069 27.508 60.6598 27.7171 61.2494L42.277 101.736L55.4932 138.506C55.7088 139.096 56.3617 139.407 56.9511 139.191L74.0149 133.054L112.897 119.075L48.3495 52.9316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.4438 41.0879L48.0714 44.581C47.4565 44.6888 47.038 45.2784 47.1458 45.8997L48.3503 52.9305L54.4164 88.3004L61.0149 126.815C61.1227 127.43 61.7185 127.848 62.3334 127.747L80.2085 124.678L112.897 119.074L120.586 117.755H116.561L68.4438 41.0879Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.264 97.4105V44.5047V43.9532V43.7693C138.264 43.4269 138.118 43.3699 137.592 42.8563L124.592 30.4557C123.977 29.8724 123.876 29.7266 123.514 29.7266H122.627H69.6288C68.9759 29.7266 68.4434 30.2591 68.4434 30.9122V116.563C68.4434 117.216 68.9759 117.755 69.6288 117.755H137.079C137.732 117.755 138.264 117.216 138.264 116.563V97.4105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.4434 41.0879L63.6704 41.9058V120.944C63.6704 121.604 64.2029 122.136 64.8558 122.136H83.7767H95.0343L112.897 119.074L120.585 117.755H116.56H111.61H88.5497H69.6288C68.9759 117.755 68.4434 117.217 68.4434 116.564C68.4434 91.4068 68.4434 66.2441 68.4434 41.0879Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.4163 88.3015L48.3501 52.9316C46.7084 53.4832 45.073 54.0347 43.4438 54.5863L44.1983 58.9799L50.2644 94.3498L56.8694 132.864C56.9707 133.479 57.5665 133.897 58.1814 133.796L76.0564 130.728L84.5377 129.276L110.083 120.083L109.778 119.608L95.0346 122.137L80.2085 124.68L62.3334 127.748C61.7186 127.85 61.1228 127.431 61.0149 126.816L54.4163 88.3015Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.264 97.4105V44.5047V43.9532C138.264 43.3128 138.054 43.3066 137.592 42.8563L124.591 30.4557C123.976 29.8724 123.875 29.7266 123.513 29.7266H122.626H109.435C125.554 51.3073 126.473 90.2084 114.512 114.49C113.961 115.618 113.384 116.703 112.782 117.755H116.56H120.585H137.078C137.731 117.755 138.264 117.216 138.264 116.563V97.4105Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.652 41.4871C122.652 44.118 125.06 43.9532 126.22 43.9532H138.264V43.7693C138.264 43.4269 138.118 43.3699 137.592 42.8563L124.592 30.4557C123.977 29.8724 123.875 29.7266 123.514 29.7266H122.626L122.652 41.4871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.592 42.8563L124.592 30.4557C123.977 29.8724 123.875 29.7266 123.514 29.7266H122.626L122.652 41.4869C122.652 44.1178 125.06 43.9529 126.22 43.9529H138.264V43.7691C138.264 43.4269 138.118 43.3699 137.592 42.8563Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.552 55.654H79.8283C78.9065 55.654 78.1592 54.9065 78.1592 53.9842C78.1592 53.0619 78.9065 52.3145 79.8283 52.3145H127.552C128.474 52.3145 129.221 53.0619 129.221 53.9842C129.221 54.9065 128.474 55.654 127.552 55.654Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.552 67.5153H79.8283C78.9065 67.5153 78.1592 66.7678 78.1592 65.8455C78.1592 64.9233 78.9065 64.1758 79.8283 64.1758H127.552C128.474 64.1758 129.221 64.9233 129.221 65.8455C129.221 66.7678 128.474 67.5153 127.552 67.5153Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.552 79.3786H79.8283C78.9065 79.3786 78.1592 78.6311 78.1592 77.7088C78.1592 76.7866 78.9065 76.0391 79.8283 76.0391H127.552C128.474 76.0391 129.221 76.7866 129.221 77.7088C129.221 78.6311 128.474 79.3786 127.552 79.3786Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.552 91.2399H79.8283C78.9065 91.2399 78.1592 90.4924 78.1592 89.5702C78.1592 88.6479 78.9065 87.9004 79.8283 87.9004H127.552C128.474 87.9004 129.221 88.6479 129.221 89.5702C129.221 90.4924 128.474 91.2399 127.552 91.2399Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.552 103.099H79.8283C78.9065 103.099 78.1592 102.352 78.1592 101.43C78.1592 100.507 78.9065 99.7598 79.8283 99.7598H127.552C128.474 99.7598 129.221 100.507 129.221 101.43C129.221 102.352 128.474 103.099 127.552 103.099Z",
    fill: "#D2D2D2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11253_30968"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110.612,
    height: 110.612,
    fill: "white",
    transform: "translate(27.6528 29.1895)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfref);
export default __webpack_public_path__ + "static/media/pdfref.bb76683601dccbda5cd487c719c58632.svg";
export { ForwardRef as ReactComponent };